import { useSelector } from "react-redux";

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { createStyles, makeStyles } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";

import "../BankAccounts/bankDialog.scss";

import colorVariables from "@root/configs/colorVariables";
import { PrimaryDarkButton, SecondaryButton } from "@root/components/auth";
import useLogin from "@root/hooks/useLogin";

interface IBankDialog {
  onClose: (value: string) => void;
  open: boolean;
}

export const LogoutDialog = ({ onClose, open }: IBankDialog) => {
  const { primaryColor, secondaryColor } = useSelector(
    (state: any) => state.whiteLabellingData
  );

  const defPrimaryColor = primaryColor ? primaryColor : colorVariables.primary;
  const defSecondaryColor =
    secondaryColor || colorVariables.defaultPrimarycolor;

  const classes = useStyles({
    defPrimaryColor,
    defSecondaryColor,
  });

  const { handleLogout } = useLogin();

  return (
    <Dialog open={open} className="paymentsDialog">
      <IconButton className="close-btn" onClick={() => onClose("X")}>
        <CloseIcon />
      </IconButton>

      <DialogContent className="w-full">
        <h1 className={classes.title}>
          <span className="">Are you sure you</span>
          <span className="">want to logout?</span>
        </h1>
      </DialogContent>

      <DialogActions className="flex items-center justify-center gap-2">
        <PrimaryDarkButton padding="12px 0px" onClick={handleLogout} title="Yes" />
        <SecondaryButton padding="12px 0px" onClick={() => onClose("No")} title="No" />
      </DialogActions>
    </Dialog>
  );
};

interface IProps {
  defPrimaryColor: string;
  defSecondaryColor: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    title: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",

      fontSize: 18,
      fontFamily: "Wix Madefor Text",
      fontWeight: "600",
    },

    button: {
      border: "0.50px solid #E1EBF6",
      color: "white",
      fontSize: 14,
      height: "45px",
      width: "90px",
      fontFamily: "Wix Madefor Text",
      fontWeight: "700",
      wordWrap: "break-word",
      padding: "10px 30px",
    },

    primary: {
      backgroundColor: (props: IProps) => props.defPrimaryColor,

      "&:hover": {
        backgroundColor: (props: IProps) => props.defPrimaryColor,
        color: "white",
        border: (props: IProps) => `0.50px solid ${props.defSecondaryColor}`,
      },
    },
    secondary: {
      backgroundColor: (props: IProps) => props.defSecondaryColor,

      "&:hover": {
        backgroundColor: (props: IProps) => props.defSecondaryColor,
        color: "white",
        border: (props: IProps) => `0.50px solid ${props.defPrimaryColor}`,
      },
    },
  })
);